import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.StandaloneRequestFieldsSection', {
    amountPlaceholder: 'Set an amount',
    standaloneFieldPlaceholder: 'Choose a value',
    currencyFieldLabel: 'Currency',
    amountFieldLabel: 'Amount',
    dateFieldLabel: 'Date',
    dateFieldPlaceholder: 'Enter date',
});
